import React, { useState } from "react";

import { MdModeEdit, MdDelete } from "react-icons/md";
import { BsFillEyeFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { useDragControls, Reorder } from "framer-motion";

import SweetAlert from "react-bootstrap-sweetalert";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import { Box, IconButton, Modal } from "@mui/material";
import { Post } from "utils/request";
import DefaultButton from "components/DefaultButton";
import { Show } from "actions/SnackbarActions";
import { STORAGE_URL } from "variables";
import AsideBannerEdit from './Edit'

const modal_style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  borderRadius: "0.4rem",
  maxWidth: "100%",
  minWidth: "36rem",
  height: "max-content",
  display: "flex",
  flexDirection: "column",
  padding: "2rem 3rem",
  justifyContent: "center",
  alignItems: "center",
};


const Board = (props) => {
  const { value, id, draggable = true, OnDelete = () => {} } = props;

  // modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [popup, SetPopup] = useState(false);

  const [loading, SetLoading] = useState(false);

  const dispatch = useDispatch();
  const dragControls = useDragControls();

  const Delete = async () => {
    let form = new FormData();
    form.append("id", id);

    SetLoading(true);
    let response = await Post("courses-main/free-courses/delete", form);
    SetLoading(false);

    if (response?.status) {
      dispatch(
        Show({
          show: true,
          message: response?.message,
          severity: response?.severity,
        })
      );
      OnDelete();
    }
  };

  const getVideoThumbnail = (link) => {
    try {
      const videoId = link.split("=")[1];
      return `https://i3.ytimg.com/vi/${videoId}/sddefault.jpg`;
    } catch {
      return "";
    }
  };

  return (
    <Reorder.Item
      value={value}
      dragListener={false}
      dragControls={dragControls}
      as="tr"
    >
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modal_style}>
          <AsideBannerEdit {...{ handleClose, OnDelete, value }} />
        </Box>
      </Modal>
      
      <IconButton
        component="td"
        onPointerDown={(e) => draggable && dragControls.start(e)}
        style={{
          cursor: draggable ? "pointer" : "not-allowed",
          touchAction: "pan-x",
        }}
      >
        <DragHandleIcon />
      </IconButton>
      <td>
        <img
          src={getVideoThumbnail(value.link)}
          alt={value.title}
          style={{ width: "8rem", height: "4rem", objectFit: 'cover' }}
        />
      </td>
      <td
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "8rem",
        }}
      >
        <Box
          dangerouslySetInnerHTML={{
            __html: value.name,
          }}
        />
      </td>
      <td
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "8rem",
        }}
      >
        <Box
          dangerouslySetInnerHTML={{
            __html: value.description,
          }}
        />
      </td>
      <td>
        <SweetAlert
          warning
          title={"Atenção"}
          onConfirm={() => {
            Delete();
            SetPopup(false);
          }}
          onCancel={() => SetPopup(false)}
          show={popup}
          confirmBtnText="Deletar"
          cancelBtnText="Cancelar"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="primary"
          showCancel={true}
        >
          Tem certeza que deseja deletar essa categoria?
        </SweetAlert>
        {/* <DefaultButton
          to={`/categories/${id}/view`}
          width="2.2em"
          height="2.2em"
          padding={0}
          title={`Ver sobre categoria`}
          bg="warning"
          icon={<BsFillEyeFill size={17} color="white" />}
        /> */}
        <DefaultButton
          // to={`/categorias/editar/${id}`}
          width="2.2em"
          height="2.2em"
          padding={0}
          title={`Editar categoria`}
          bg="info"
          icon={<MdModeEdit color="white" size={17} />}
          style={{
            margin: "0 2px",
          }}
          onClick={handleOpen}
        />
        <DefaultButton
          onClick={() => SetPopup(true)}
          width="2.2em"
          height="2.2em"
          padding={0}
          title={`Deletar categoria`}
          bg="danger"
          loading={loading}
          icon={!loading && <MdDelete size={17} color="white" />}
        />
      </td>
    </Reorder.Item>
  );
};

export default Board;
